import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBars,
    faUser,
    faCaretDown,
    faCaretUp,
    faKey,
    faPowerOff,
    faEnvelopeOpenText
} from "@fortawesome/free-solid-svg-icons";
import { Navbar, NavbarBrand } from 'reactstrap';
import { Popover, PopoverBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
//Api
import correioInterno_api from '../../api/correioInterno_api';
import setup_api from '../../api/setup_api';

//Helpers
import { showMessage } from '../../helpers/message';

import { useAuth } from '../../context/auth';

export default function Navigation({ icon = null, brand, button, color, iconColor, toggle, border, userMenu, notification, logoGestao = false }) {
    const { session, signOut } = useAuth();
    //Estado para deixar o icone de mensagem interna vermelho
    const [redMessage, setRedMessage] = useState(false);
    //Estado de controle para abrir o popover de sair do sistema e trocar senha
    const [openPopover, setOpenPopover] = useState(false);

    //Estado de controle da logo da gestão
    const [logos, setLogos] = useState(null);

    //Variavel de navegação
    const navigate = useNavigate();


    //Função que carrega os dados da logo
    const loadLogoTiposCidade = () => {
        setup_api.GetLogotiposPrefeituraHome()
            .then(response => {
                if (response?.data?.logotipo != null || response?.data?.logotipoSecretaria != null)
                    setLogos(response.data);
            })
            .catch(err => showMessage("Erro", "Error na operação.", "error", null));
    }

    useEffect(() => {
        loadLogoTiposCidade();
    }, []);

    //Confere se tem mensagens pendentes de leitura
    useEffect(() => {
        if (notification) {
            correioInterno_api.GetList().then(response => {
                setRedMessage(response.data.filter(x => x.status === "Mensagem Não Lida").length > 0);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
        }
    }, [notification]);


    //Troca o estado do popover
    function togglePopover() {
        setOpenPopover(!openPopover);
    }

    //Carrega a tela de mensagens internas
    function loadTelaNotificacoes() {
        navigate("/admin/mensagem-interna");
    }

    return (

        <Navbar
            expand="md"
            dark
            style={{ backgroundColor: color ? color : "#06414B", borderBottom: border ? border : "" }}
        >
            <div className='d-flex align-items-center justify-content-between w-100'>

                <div className='d-flex align-items-center justify-content-start align w-50 '>
                    {button && <FontAwesomeIcon className='p-1 me-4' icon={faBars} onClick={toggle} style={{ color: iconColor ? iconColor : "#fff" }} />}
                    {logoGestao && logos &&
                        <NavbarBrand className='p-0 m-0'>
                            <div className="d-flex align-items-center mx-5">
                                <div className='mr-3'>
                                    {logos?.logotipo && <img className="mb-1 mx-1" height={"40px"} id="img_logotipo" src={"data:image/png;base64," + logos.logotipo}></img>}
                                </div>
                                <div>
                                    {logos?.logotipoSecretaria && <img height={"40px"} id="img_logotipo" src={"data:image/png;base64," + logos.logotipoSecretaria}></img>}
                                </div>
                            </div>
                        </NavbarBrand>
                    }
                    {(!logos || !logoGestao) && <NavbarBrand className='p-0 m-0'><br /></NavbarBrand>}
                    {icon && <FontAwesomeIcon icon={icon} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />}
                    {brand && <p style={{ color: iconColor ? iconColor : "#fff" }} className="m-0">{brand}</p>}
                </div>
                {!userMenu && !icon && !brand && window.location.pathname == "/auth/login" &&
                    <button type="button" className="btn btn-outline-light" onClick={() => navigate("/auth/transportadoresCredenciados")} >
                        Transportadores Credenciados
                    </button>
                }
                {!userMenu && !icon && !brand && window.location.pathname == "/auth/transportadoresCredenciados" &&
                    <NavbarBrand className='p-0 m-0'><br /></NavbarBrand>
                }
                {userMenu
                    ?
                    <>
                        <div className='d-flex align-items-center justify-content-between'>
                            {notification &&
                                <FontAwesomeIcon icon={faEnvelopeOpenText} className={` me-3 ${redMessage ? "text-danger" : "text-light"}`} size={"lg"} style={{ cursor: "pointer" }} onClick={loadTelaNotificacoes} />
                            }
                            <span className='text-light me-3'>{session && session.nome}</span>
                            <div id="PopoverUserMenu" onClick={togglePopover}>
                                <FontAwesomeIcon icon={faUser} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />
                                <FontAwesomeIcon icon={openPopover ? faCaretDown : faCaretUp} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />
                            </div>
                        </div>

                        <Popover placement="bottom" isOpen={openPopover} target="PopoverUserMenu" toggle={togglePopover} className="popOverMenuUser">
                            <PopoverBody className='popOverBodyMenuUser shadow'>
                                <ul className='listUserMenu'>
                                    <li>
                                        <a href="/admin/trocarsenha" >
                                            <FontAwesomeIcon icon={faKey} style={{ color: "#333" }} className="me-3" />
                                            Trocar Senha
                                        </a>

                                    </li>
                                    <li>
                                        <Link onClick={() => signOut()} to="/auth/login" >
                                            <FontAwesomeIcon icon={faPowerOff} style={{ color: "#333" }} className="me-3" />
                                            Sair
                                        </Link>
                                    </li>
                                </ul>
                            </PopoverBody>
                        </Popover>
                    </>
                    : <></>
                }

            </div>
        </Navbar>
    )
}